/**
 * Copy for the pages AI apps (Platform MCP) send a user to (upload, API-key connect,
 * OAuth landing). Each one ends the same way: the user goes back to the chat,
 * where the assistant picks up from here.
 */
export const ASSISTANT_COPY = {
  backToChat: 'Go back to your chat.',
  uploaded: 'Uploaded — go back to your chat.',
  uploadedHint: 'Your files are processing. Your AI app can follow their progress for you. You can close this tab.',
  folderUnavailable: "This folder isn't available to you.",
  folderUnavailableHint:
    'It may have been deleted, or it is no longer shared with you. Ask your AI app to list your folders again.',
  folderLoadFailed: "Couldn't open this folder. Check your connection and try again.",
  noIntegrations: "You don't have access to integrations.",
  noIntegrationsHint: 'Ask your company admin for access, or connect the app another way.',
  appNotFound: (toolkit) => `We couldn't find the app “${toolkit}”.`,
  appNotFoundHint: 'Ask your AI app to search for the app again.',
  appsLoadFailed: "Couldn't load this app. Check your connection and try again.",
  connected: (appName) => `${appName || 'The app'} is connected — go back to your chat.`,
  connectedHint: 'You can close this tab.',
  connectCancelled: 'Not connected yet.',
  connectCancelledHint: 'Open the form again to enter the key, or go back to your chat.',
  oauthFailed: "The sign-in didn't complete.",
  oauthFailedHint: 'Ask your AI app to connect the app again.',
};

/** Query flag the upload screens read to end on "go back to your chat". */
export const FROM_ASSISTANT_PARAM = 'from';
export const FROM_ASSISTANT_VALUE = 'assistant';
